/** This file is auto generated by convertSvgToJsx.ts */

import React from 'react'
import type { IconSVGProps } from '../../components/icon/Icon'
const send = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 16 16"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="m7.225 10.26 3.241 4.326a1.035 1.035 0 0 0 1.846-.43l2.24-11.928a1.035 1.035 0 0 0-1.566-1.07l-11.5 7.188a1.035 1.035 0 0 0 .55 1.913h5.189Zm0 0H5.669v3.216a1.035 1.035 0 0 0 1.618.855l1.977-1.348-2.04-2.724Zm0 0 6.893-9.078"
    />
  </svg>
)
export default send
